import { action } from 'satcheljs';
import PontType from 'owa-service/lib/contract/PontType';

export default action('updateUserConfigurationPont', (pontType: PontType) => {
    return {
        pontType: pontType,
    };
});
